import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Roles } from '../../constant/roles';
import { UserStore } from '../../store/user.store';

import { RoleService } from '../../service/role.service';

@Injectable({
    providedIn: 'root'
})
export class CheckAdmin implements CanLoad, CanActivate {
    constructor(private router: Router, private roleService: RoleService, private usrStore: UserStore) {
    }

    async canLoad() {
        console.log('CheckAdmin');
        return this.roleService.hasAdmin();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        console.log('CheckAdmin => check canActivate');
        if (this.roleService.hasAdmin())
            return true;
        else {
            let page = '/login';
            if (this.usrStore.userLogged) {
                page = '/app/tabs/home';
            } 
            this.router.navigate([page]);
            return false;
        }
    }
}
